import { render, staticRenderFns } from "./PosModal.vue?vue&type=template&id=12180cfa&scoped=true&"
import script from "./PosModal.vue?vue&type=script&lang=js&"
export * from "./PosModal.vue?vue&type=script&lang=js&"
import style0 from "./PosModal.vue?vue&type=style&index=0&id=12180cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12180cfa",
  null
  
)

export default component.exports